import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../i18';

const ErrorPage = () => {
    const { t } = useTranslation();
    return (
        <div className="error-page d-flex align-items-center justify-content-center vh-100">
            <div className="text-center">
                <h1 className="display-4 text-danger">404</h1>
                <h2 className="mb-4">{t('pageNotFound')}</h2>
                <p className="mb-4 text-muted">{t('error404')}</p>
                <Link to="/" className="btn btn-primary">
                    {t('goToHome')}
                </Link>
            </div>
        </div>
    );
};

export default ErrorPage;